/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Locations/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import DataVaxiomSysOrganizationsLocationsSelect from 'DesignSystem/DataVaxiomSysOrganizationsLocationsSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Locations({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/Old/Locations"
  
}) {
let selectedLocationIdsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'location_ids',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<DataVaxiomSysOrganizationsLocationsSelect
  viewPath={`${viewPath}/DataVaxiomSysOrganizationsLocationsSelect`}
 data="selected.location_ids"
 value={selectedLocationIdsValueData}
 onChange={onChange}
/>
{children}
</React.Fragment>)
}